import type { Settings, SettingsUpdate } from '@lms/shared-types'
import { apiRequest } from './client'

export function getSettings(): Promise<Settings> {
  return apiRequest<Settings>('/api/v1/settings')
}

export function updateSettings(input: SettingsUpdate): Promise<Settings> {
  return apiRequest<Settings>('/api/v1/settings', {
    method: 'PATCH',
    body: input,
  })
}
